import { useApplicationVideoGates } from '@mp';
import { useMatch } from 'react-router-dom';

export const useIsApplicationVideoHeader = (): boolean => {
  const isApplicationRoute = useMatch('/application/*');
  const { isProAppVideoEnabled } = useApplicationVideoGates();

  return Boolean(isApplicationRoute) && isProAppVideoEnabled;
};
